<script setup>
  import { ref, watch } from 'vue'
  import { VueDatePicker } from '@vuepic/vue-datepicker';
  import { de } from 'date-fns/locale'
  import '@vuepic/vue-datepicker/dist/main.css'

  const props = defineProps({
    filter: Object,
    activeFilters: Object
  })

  const emit = defineEmits(['updateFilter'])
  const dates = ref()

  watch(dates, (value) => {
    if (!value || value == null) {
      emit('updateFilter', null, props.filter.target)
      return
    }

    const timestamp = value.map((date) => {
      return new Date(date).getTime()
    })
    emit('updateFilter', timestamp, props.filter.target)
  })

  watch(() => props.activeFilters, (value) => {
    if (!value || !value[props.filter.target]) {
      dates.value = undefined
    }
  })

</script>

<template>
  <div class="min-w-lg w-full lg:w-fit">
    <label
      :for="filter.target"
      class="block text-sm/6 text-body">
      {{ filter.title }}
    </label>
    <div class="mt-2 grid grid-cols-1 min-w-lg">
      <VueDatePicker
        v-model="dates"
        :formats="{ input: 'dd.MM.yyyy' }"
        :time-config="{ enableTimePicker: false }"
        :locale="de"
        multi-calendars
        range
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep(.dp--action-button.dp--action-select) {
  @apply bg-primary px-2 py-1;
}
</style>
